export const popupBlockedTitle = "GKE3Jb";
export const popupBlockedMessage = "n37rz";
export const popupBlockedSettingsPrefix = "NLJWpe";
export const popupBlockedEnablePopupsLinkText = "pZVpbc";
export const popupBlockedSettingsSuffix = "_GIBO";
export const popupBlockedRetryButton = "qpRAWd";
export default {popupBlockedTitle,popupBlockedMessage,popupBlockedSettingsPrefix,popupBlockedEnablePopupsLinkText,popupBlockedSettingsSuffix,popupBlockedRetryButton};